import { GlobalConfigType } from 'actions'
import { store } from 'reducers'
import { checkFirst2Letters } from 'utils'

export const IneligiblePartiesList: Record<string, string> = {
  guarantor: 'Guarantor',
  appraiser: 'Appraiser',
  contractor: 'Contractor',
  settlement: 'Settlement Agent',
}

/** Same split as backend `ineligible-party-validate.ts` (first token / rest). */
const parseFullName = (fullName: string) => {
  const parts = fullName.trim().split(' ')
  return {
    firstName: parts[0] || '',
    lastName: parts.slice(1).join(' ') || '',
  }
}

export const getSimliarIneligibleParties = () => {
  const rtl: Record<string, Array<Array<string>>> = {}
  try {
    const { loanDetail, borrower, globalConfigReducer } = store.getState()
    const ineligibleParties = globalConfigReducer[GlobalConfigType.IneligibleParties]

    Object.keys(IneligiblePartiesList).map((key) => {
      rtl[key] = []
      const loanPartyNames: Array<Array<string>> = []
      Object.keys(loanDetail?.closeParties)?.map((subKey) => {
        const { FirstName, LastName, Company } = loanDetail.closeParties[subKey]
        loanPartyNames.push([FirstName, LastName])
        // Title companies / settlement agents are often listed by company name
        // (e.g. "Priority Title & Escrow"), not the contact First/Last Name.
        if (Company?.trim()) {
          const { firstName, lastName } = parseFullName(Company)
          loanPartyNames.push([firstName, lastName])
        }
      })
      Object.keys(borrower).map((subKey) => {
        if (!borrower[subKey].isIncluded) return
        const { firstName, lastName } = borrower[subKey]
        loanPartyNames.push([firstName, lastName])
      })
      loanPartyNames.map((party) => {
        ineligibleParties[key]?.map((item: string) => {
          const { firstName, lastName } = parseFullName(item)
          if (checkFirst2Letters(firstName, party[0]) && checkFirst2Letters(lastName, party[1])) {
            const originName = `${party[0]} ${party[1]}`.trim()
            const existingIdx = rtl[key].findIndex((v) => v[0] === originName && v[1] === item)
            if (existingIdx === -1) rtl[key].push([originName, item])
          }
        })
      })
    })
  } catch {}
  return rtl
}

export const isIneligiblePartyCleared = () => {
  const { loan } = store.getState()
  const ineligibleParties = getSimliarIneligibleParties()

  let rtl = true
  Object.keys(ineligibleParties).forEach((key) => {
    ineligibleParties[key]?.map((item) => {
      if (!loan.ineligiblePartyCleared?.[`${item[0]}-${item[1]}`]) rtl = false
    })
  })

  return rtl
}
